import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { RequestsService } from "../../../services/requests.service";
import { ContragentHistoryRequestDto } from "../../../models/request/contragent-history-request.dto";
import { Subject } from "rxjs";
import { takeUntil, tap } from "rxjs/operators";
import { NgbTabChangeEvent } from "@ng-bootstrap/ng-bootstrap";
import { RequestType } from "../../../enums";

@Component({
    selector: 'request-page-contragent-history-requests',
    templateUrl: './request-page-contragent-history-requests.component.html',
    styleUrls: ['./request-page-contragent-history-requests.component.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
    ],
    encapsulation: ViewEncapsulation.None,
})
export class RequestPageContragentHistoryRequestsComponent implements OnInit, OnDestroy {

    @Input() requestId: number;
    @Input() contragentId: number;
    @Input() customerObjectId: number;

    private _destroy$ = new Subject<boolean>();
    private readonly defaultRequestStatusColor: string = '#e8e8e8';

    constructor(
        private requestsService: RequestsService
    ) { }

    contragentHistoryRequests: ContragentHistoryRequestDto[] = [];
    customerObjectHistoryRequests: ContragentHistoryRequestDto[] = [];
    reclamationHistoryRequests: ContragentHistoryRequestDto[] = [];

    activeIdString: string = 'contragent';
    loading: boolean = false;

    ngOnInit(): void {
        this.loading = true;
        this.requestsService.getContragentHistoryRequests(this.contragentId)
        .pipe(tap(() => takeUntil(this._destroy$)))
        .subscribe(resp => {
            this.contragentHistoryRequests = resp.filter(x => x.requestId != this.requestId);
            this.customerObjectHistoryRequests = this.customerObjectId
                ? this.contragentHistoryRequests.filter(x => x.customerObjectId == this.customerObjectId)
                : [];
            this.reclamationHistoryRequests = resp.filter(x => x.requestTypeId == <number>RequestType.reclamation);
            this.loading = false;
        });
    }

    ngOnDestroy(): void {
        this._destroy$.next(true);
		this._destroy$.complete();
    }

    tabChanged(e: NgbTabChangeEvent) {
        this.activeIdString = e.nextId;
    }

    getStatusColor(dataItem: ContragentHistoryRequestDto) {
        return dataItem.requestStatusColor ? dataItem.requestStatusColor : this.defaultRequestStatusColor;
    }

    selectRequest(requestId: number) {
        window.open(`/requests/${requestId}`, '_blank');
    }
}